module.exports = __webpack_public_path__ + "static/media/bg-index.be70d7dd.jpg";